// src/hooks/useAnalyticsEventTracker.ts
import ReactGA from "react-ga4";
import { AnalyticsEvent } from "../types/analyticsEvent";

const useAnalyticsEventTracker = () => {
  const eventTracker = (event: AnalyticsEvent) => {
    ReactGA.event({
      category: event.category,
      action: event.action,
      label: event.label,
    });
  };
  return eventTracker;
};

export default useAnalyticsEventTracker;
